import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'frontend-chat-list-empty-result',
  templateUrl: 'chat-list-empty-result.component.html',
  styleUrls: ['chat-list-empty-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ChatListEmptyResultComponent {}
